(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nouralume-newsletter-popup"]) return;
  try {
    
  (() => {
    const dialog = document.getElementById('NouralumeWelcome');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const form = dialog.querySelector('form');
    const key = 'nouralume-welcome-v1';
    const pendingKey = key + '-pending';
    const read = (storage, name) => { try { return storage.getItem(name); } catch { return null; } };
    const write = (storage, name, value) => { try { storage.setItem(name, value); } catch {} };
    const remove = (storage, name) => { try { storage.removeItem(name); } catch {} };
    let storage;
    let session;
    try { storage = window.localStorage; session = window.sessionStorage; } catch {}
    let previousFocus;
    let previousOverflow;
    let timer;
    let openedAt;
    const eligible = () => dialog.dataset.subscribed !== 'true' && read(storage, key + '-subscribed') !== '1';
    const lastVisit = Number(read(session, key + '-last-visit'));
    if (!lastVisit || Date.now() - lastVisit > 1800000) {
      remove(session, key + '-shown');
      remove(session, key + '-reminded');
      remove(session, key + '-reminder-due');
    }
    write(session, key + '-last-visit', String(Date.now()));
    const open = () => {
      if (dialog.open) return;
      if (document.querySelector('dialog[open]')) return;
      previousFocus = document.activeElement;
      previousOverflow = document.body.style.overflow;
      dialog.showModal();
      openedAt = performance.now();
      write(session, key + '-shown', '1');
      remove(session, key + '-reminder-due');
      document.body.style.overflow = 'hidden';
    };
    const dismiss = () => {
      clearTimeout(timer);
      const quickClose = performance.now() - openedAt <= 3000;
      dialog.close();
      if (quickClose && eligible() && read(session, key + '-reminded') !== '1') {
        write(session, key + '-reminded', '1');
        write(session, key + '-reminder-due', String(Date.now() + 30000));
        timer = setTimeout(() => { if (eligible()) open(); }, 30000);
      }
    };
    dialog.querySelectorAll('[data-welcome-close]').forEach(button => button.addEventListener('click', dismiss));
    dialog.addEventListener('cancel', event => { event.preventDefault(); dismiss(); });
    dialog.addEventListener('click', event => {
      const rect = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dismiss();
    });
    dialog.addEventListener('close', () => {
      document.body.style.overflow = previousOverflow || '';
      if (previousFocus && previousFocus.isConnected) previousFocus.focus({ preventScroll: true });
    });
    form.addEventListener('submit', () => { clearTimeout(timer); write(session, pendingKey, '1'); });
    const launcher = document.querySelector('[data-welcome-launch]');
    launcher?.addEventListener('click', () => { clearTimeout(timer); open(); });
    const copy = dialog.querySelector('[data-welcome-copy]');
    copy.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(dialog.querySelector('[data-welcome-code]').textContent.trim());
        copy.textContent = copy.dataset.copiedLabel;
      } catch {
        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(dialog.querySelector('[data-welcome-code]'));
        selection.removeAllRanges();
        selection.addRange(range);
      }
    });
    const state = dialog.querySelector('[data-welcome-state]').dataset.welcomeState;
    const pending = read(session, pendingKey) === '1';
    const formReturn = window.location.hash === '#NouralumeNewsletterForm';
    if ((pending || formReturn) && state !== 'idle') {
      remove(session, pendingKey);
      if (state === 'success') write(storage, key + '-subscribed', '1');
      open();
      return;
    }
    if (state === 'success') { write(storage, key + '-subscribed', '1'); return; }
    if (!eligible()) return;
    const reminderDue = Number(read(session, key + '-reminder-due'));
    if (reminderDue) {
      timer = setTimeout(() => { if (eligible()) open(); }, Math.max(0, reminderDue - Date.now()));
      return;
    }
    if (read(session, key + '-shown') === '1') return;
    timer = setTimeout(open, Math.max(0, Number(dialog.dataset.delay) - performance.now()));
  })();

  } catch(e) { console.error(e); }
})();
})();
